export const GET_MANAGEMENT_COMPANY_REQUEST = 'GET_MANAGEMENT_COMPANY_REQUEST';
export const GET_MANAGEMENT_COMPANY_SUCCESS = 'GET_MANAGEMENT_COMPANY_SUCCESS';
export const GET_MANAGEMENT_COMPANY_FAILURE = 'GET_MANAGEMENT_COMPANY_FAILURE';